import memoize from "memoize-one";
import { PureComponent } from "react";
import { connect } from "react-redux";

import { Loader, LoaderSize } from "components/loader";
import { Table } from "components/table";
import { ReportType } from "constants/reports/report-type";
import { trackScheduledReportAction } from "helpers/analytics-reports";
import { navigate } from "helpers/routing";
import { IScheduledReport, IScheduledReportsData } from "store/views/reports/interfaces";
import { getHighlightedIds, getIsReportFetching, getReportData } from "store/views/reports/selectors";

import ScheduledReportEmptyState from "../components/ScheduledReportEmptyState";
import { card, cardBody, cardTitle } from "../styled/card";
import { containerFluid } from "../styled/layout";
import {
  TableHeader,
  headerRowStyles,
  reportFieldStyles,
  rowHighlight,
  textOverflowStyles,
  width10Styles,
  width20Styles,
  width30Styles,
} from "../styled/scheduled-reports-table";

import DeleteScheduledReportModal from "./DeleteScheduledReportModal";
import { ScheduledReportsDropdown } from "./ScheduledReportsDropdown";

interface IStateProps {
  isFetching: boolean;
  data: IScheduledReportsData;
  highlightedIds: string[];
}

interface IState {
  id: string;
  modalHeader: string;
  isModalOpen: boolean;
  highlightedReports: string[];
}

type IProps = IStateProps;

class ScheduledReports extends PureComponent<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.state = {
      id: "",
      modalHeader: "",
      isModalOpen: false,
      highlightedReports: this.props.highlightedIds || [],
    };

    this.memoizedGetReports = memoize((data: IScheduledReportsData) => this.getReports(data));
  }

  getReports(scheduledReports: IScheduledReportsData): JSX.Element[] {
    const { data = [], sortedIds = [] } = scheduledReports;
    // @ts-expect-error TS(2322): Type '(Element | null)[]' is not assignable to typ... Remove this comment to see the full error message
    return sortedIds.map(id => {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      const report = data[id];
      if (report) {
        const isHighlighted = this.state.highlightedReports.includes(id);
        return (
          <tr key={report.id} css={[isHighlighted && rowHighlight]}>
            <td css={[reportFieldStyles, width20Styles]}>{report.source}</td>
            <td css={[reportFieldStyles, width20Styles]}>{report.recurs}</td>
            <td css={[reportFieldStyles, width20Styles]}>{report.nextReport}</td>
            <td css={[reportFieldStyles, width30Styles, textOverflowStyles]}>
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
              {report.recipients.map((item: any, i: any) =>
                report.recipients.length === i + 1 ? `${item}` : `${item}, `
              )}
            </td>
            <td css={[reportFieldStyles, width10Styles]}>
              <ScheduledReportsDropdown onChange={this.handleChange(report)} />
            </td>
          </tr>
        );
      }
      return null;
    });
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleModalOpen = () => this.setState({ isModalOpen: true });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleChange = (report: IScheduledReport) => (item: string) => {
    const { id, recurs, source } = report;
    if (item === "edit") {
      const path = id.replace("-", "/");
      navigate(`/reports/scheduled-reports/edit/${path}`);
      trackScheduledReportAction("edit");
    }
    if (item === "delete") {
      this.setState(
        {
          id,
          modalHeader: `Delete ${recurs} ${source.toLowerCase()} report?`,
        },
        () => this.handleModalOpen()
      );
      trackScheduledReportAction("delete");
    }
  };

  memoizedGetReports: (data: IScheduledReportsData) => JSX.Element[];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { isModalOpen, modalHeader } = this.state;
    const { isFetching, data } = this.props;

    const reports = data ? this.memoizedGetReports(data) : [];

    if (!reports.length && !isFetching) {
      return <ScheduledReportEmptyState />;
    }

    return (
      <div css={containerFluid}>
        {reports.length > 0 && (
          <div css={card}>
            <div css={cardTitle}>
              Scheduled reports
              {isFetching && <Loader size={LoaderSize.Small} inline />}
            </div>
            <div css={cardBody}>
              <Table
                thead={
                  <thead>
                    <tr css={headerRowStyles}>
                      <TableHeader width="20%">Source</TableHeader>
                      <TableHeader width="20%">Recurs</TableHeader>
                      <TableHeader width="20%">Next report</TableHeader>
                      <TableHeader width="30%">Recipients</TableHeader>
                      <TableHeader width="10%">&nbsp;</TableHeader>
                    </tr>
                  </thead>
                }
                tbody={<tbody>{reports}</tbody>}
              />
            </div>
          </div>
        )}
        {isModalOpen && (
          <DeleteScheduledReportModal id={this.state.id} modalHeader={modalHeader} onClose={this.handleModalClose} />
        )}
      </div>
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any): IStateProps => ({
  isFetching: getIsReportFetching(state, ReportType.ScheduledReports),
  // @ts-expect-error TS(2322): Type 'IScheduledReportsData | undefined' is not as... Remove this comment to see the full error message
  data: getReportData(state, ReportType.ScheduledReports),
  highlightedIds: getHighlightedIds(state),
});

export default connect(mapStateToProps, null)(ScheduledReports);
